export function scrollToId(id) {
	const element = document.getElementById(id)

	if (element) {
		const positionElement = Number(element.dataset.position)
		if (!isNaN(positionElement)) {
			window.scrollTo({ top: positionElement, behavior: 'smooth' })
		} else {
			console.error('Erro: positionElement não é um número válido')
		}
	}
}
